import { Brain, Cpu, Sparkles, Smartphone, Bot, Layout, Terminal, ExternalLink, Flame, Target, Quote, Laptop, Monitor } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { personSchema, getBreadcrumbSchema } from '../data/schemas';

const socialLinks = [
  {
    name: 'GitHub',
    url: 'https://github.com/NottKoneko',
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
      </svg>
    ),
    hoverClass: 'hover:text-white hover:bg-white/10 hover:border-white/30 hover:shadow-white/10',
    tooltipColor: 'bg-gray-800 text-white border-gray-700'
  },
  {
    name: 'Hugging Face',
    url: 'https://huggingface.co/NotKoneko',
    icon: (
      <svg className="w-5 h-5 transition-all duration-300 filter grayscale opacity-60 group-hover/btn:grayscale-0 group-hover/btn:opacity-100" viewBox="0 0 95 88" xmlns="http://www.w3.org/2000/svg">
        <path fill="#fff" d="M94.25 70.08a8.28 8.28 0 0 1-.43 6.46 10.57 10.57 0 0 1-3 3.6 25.18 25.18 0 0 1-5.7 3.2 65.74 65.74 0 0 1-7.56 2.65 46.67 46.67 0 0 1-11.42 1.68c-5.42.05-10.09-1.23-13.4-4.5a40.4 40.4 0 0 1-10.14.03c-3.34 3.25-7.99 4.52-13.39 4.47a46.82 46.82 0 0 1-11.43-1.68 66.37 66.37 0 0 1-7.55-2.65c-2.28-.98-4.17-2-5.68-3.2a10.5 10.5 0 0 1-3.02-3.6c-.99-2-1.18-4.3-.42-6.46a8.54 8.54 0 0 1-.33-5.63c.25-.95.66-1.83 1.18-2.61a8.67 8.67 0 0 1 2.1-8.47 8.23 8.23 0 0 1 2.82-2.07 41.75 41.75 0 1 1 81.3-.12 8.27 8.27 0 0 1 3.11 2.19 8.7 8.7 0 0 1 2.1 8.47c.52.78.93 1.66 1.18 2.61a8.61 8.61 0 0 1-.32 5.63Z" />
        <path fill="#FFD21E" d="M47.21 76.5a34.75 34.75 0 1 0 0-69.5 34.75 34.75 0 0 0 0 69.5Z" />
        <path fill="#FF9D0B" d="M81.96 41.75a34.75 34.75 0 1 0-69.5 0 34.75 34.75 0 0 0 69.5 0Zm-73.5 0a38.75 38.75 0 1 1 77.5 0 38.75 38.75 0 0 1-77.5 0Z" />
        <path fill="#3A3B45" d="M58.5 32.3c1.28.44 1.78 3.06 3.07 2.38a5 5 0 1 0-6.76-2.07c.61 1.15 2.55-.72 3.7-.32ZM34.95 32.3c-1.28.44-1.79 3.06-3.07 2.38a5 5 0 1 1 6.76-2.07c-.61 1.15-2.56-.72-3.7-.32Z" />
        <path fill="#FF323D" d="M46.96 56.29c9.83 0 13-8.76 13-13.26 0-2.34-1.57-1.6-4.09-.36-2.33 1.15-5.46 2.74-8.9 2.74-7.19 0-13-6.88-13-2.38s3.16 13.26 13 13.26Z" />
        <path fill="#3A3B45" fillRule="evenodd" d="M39.43 54a8.7 8.7 0 0 1 5.3-4.49c.4-.12.81.57 1.24 1.28.4.68.82 1.37 1.24 1.37.45 0 .9-.68 1.33-1.35.45-.7.89-1.38 1.32-1.25a8.61 8.61 0 0 1 5 4.17c3.73-2.94 5.1-7.74 5.1-10.7 0-2.34-1.57-1.6-4.09-.36l-.14.07c-2.31 1.15-5.39 2.67-8.77 2.67s-6.45-1.52-8.77-2.67c-2.6-1.29-4.23-2.1-4.23.29 0 3.05 1.46 8.06 5.47 10.97Z" clipRule="evenodd" />
        <path fill="#FF9D0B" d="M70.71 37a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM24.21 37a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM17.52 48c-1.62 0-3.06.66-4.07 1.87a5.97 5.97 0 0 0-1.33 3.76 7.1 7.1 0 0 0-1.94-.3c-1.55 0-2.95.59-3.94 1.66a5.8 5.8 0 0 0-.8 7 5.3 5.3 0 0 0-1.79 2.82c-.24.9-.48 2.8.8 4.74a5.22 5.22 0 0 0-.37 5.02c1.02 2.32 3.57 4.14 8.52 6.1 3.07 1.22 5.89 2 5.91 2.01a44.33 44.33 0 0 0 10.93 1.6c5.86 0 10.05-1.8 12.46-5.34 3.88-5.69 3.33-10.9-1.7-15.92-2.77-2.78-4.62-6.87-5-7.77-.78-2.66-2.84-5.62-6.25-5.62a5.7 5.7 0 0 0-4.6 2.46c-1-1.26-1.98-2.25-2.86-2.82A7.4 7.4 0 0 0 17.52 48Zm0 4c.51 0 1.14.22 1.82.65 2.14 1.36 6.25 8.43 7.76 11.18.5.92 1.37 1.31 2.14 1.31 1.55 0 2.75-1.53.15-3.48-3.92-2.93-2.55-7.72-.68-8.01.08-.02.17-.02.24-.02 1.7 0 2.45 2.93 2.45 2.93s2.2 5.52 5.98 9.3c3.77 3.77 3.97 6.8 1.22 10.83-1.88 2.75-5.47 3.58-9.16 3.58-3.81 0-7.73-.9-9.92-1.46-.11-.03-13.45-3.8-11.76-7 .28-.54.75-.76 1.34-.76 2.38 0 6.7 3.54 8.57 3.54.41 0 .7-.17.83-.6.79-2.85-12.06-4.05-10.98-8.17.2-.73.71-1.02 1.44-1.02 3.14 0 10.2 5.53 11.68 5.53.11 0 .2-.03.24-.1.74-1.2.33-2.04-4.9-5.2-5.21-3.16-8.88-5.06-6.8-7.33.24-.26.58-.38 1-.38 3.17 0 10.66 6.82 10.66 6.82s2.02 2.1 3.25 2.1c.28 0 .52-.1.68-.38.86-1.46-8.06-8.22-8.56-11.01-.34-1.9.24-2.85 1.31-2.85Z" />
        <path fill="#FFD21E" d="M38.6 76.69c2.75-4.04 2.55-7.07-1.22-10.84-3.78-3.77-5.98-9.3-5.98-9.3s-.82-3.2-2.69-2.9c-1.87.3-3.24 5.08.68 8.01 3.91 2.93-.78 4.92-2.29 2.17-1.5-2.75-5.62-9.82-7.76-11.18-2.13-1.35-3.63-.6-3.13 2.2.5 2.79 9.43 9.55 8.56 11-.87 1.47-3.93-1.71-3.93-1.71s-9.57-8.71-11.66-6.44c-2.08 2.27 1.59 4.17 6.8 7.33 5.23 3.16 5.64 4 4.9 5.2-.75 1.2-12.28-8.53-13.36-4.4-1.08 4.11 11.77 5.3 10.98 8.15-.8 2.85-9.06-5.38-10.74-2.18-1.7 3.21 11.65 6.98 11.76 7.01 4.3 1.12 15.25 3.49 19.08-2.12Z" />
        <path fill="#FF9D0B" d="M77.4 48c1.62 0 3.07.66 4.07 1.87a5.97 5.97 0 0 1 1.33 3.76 7.1 7.1 0 0 1 1.95-.3c1.55 0 2.95.59 3.94 1.66a5.8 5.8 0 0 1 .8 7 5.3 5.3 0 0 1 1.78 2.82c.24.9.48 2.8-.8 4.74a5.22 5.22 0 0 1 .37 5.02c-1.02 2.32-3.57 4.14-8.51 6.1-3.08 1.22-5.9 2-5.92 2.01a44.33 44.33 0 0 1-10.93 1.6c-5.86 0-10.05-1.8-12.46-5.34-3.88-5.69-3.33-10.9 1.7-15.92 2.78-2.78 4.63-6.87 5.01-7.77.78-2.66 2.83-5.62 6.24-5.62a5.7 5.7 0 0 1 4.6 2.46c1-1.26 1.98-2.25 2.87-2.82A7.4 7.4 0 0 1 77.4 48Zm0 4c-.51 0-1.13.22-1.82.65-2.13 1.36-6.25 8.43-7.76 11.18a2.43 2.43 0 0 1-2.14 1.31c-1.54 0-2.75-1.53-.14-3.48 3.91-2.93 2.54-7.72.67-8.01a1.54 1.54 0 0 0-.24-.02c-1.7 0-2.45 2.93-2.45 2.93s-2.2 5.52-5.97 9.3c-3.78 3.77-3.98 6.8-1.22 10.83 1.87 2.75 5.47 3.58 9.15 3.58 3.82 0 7.73-.9 9.93-1.46.1-.03 13.45-3.8 11.76-7-.29-.54-.75-.76-1.34-.76-2.38 0-6.71 3.54-8.57 3.54-.42 0-.71-.17-.83-.6-.8-2.85 12.05-4.05 10.97-8.17-.19-.73-.7-1.02-1.44-1.02-3.14 0-10.2 5.53-11.68 5.53-.1 0-.19-.03-.23-.1-.74-1.2-.34-2.04 4.88-5.2 5.23-3.16 8.9-5.06 6.8-7.33-.23-.26-.57-.38-.98-.38-3.18 0-10.67 6.82-10.67 6.82s-2.02 2.1-3.24 2.1a.74.74 0 0 1-.68-.38c-.87-1.46 8.05-8.22 8.55-11.01.34-1.9-.24-2.85-1.31-2.85Z" />
        <path fill="#FFD21E" d="M56.33 76.69c-2.75-4.04-2.56-7.07 1.22-10.84 3.77-3.77 5.97-9.3 5.97-9.3s.82-3.2 2.7-2.9c1.86.3 3.23 5.08-.68 8.01-3.92 2.93.78 4.92 2.28 2.17 1.51-2.75 5.63-9.82 7.76-11.18 2.13-1.35 3.64-.6 3.13 2.2-.5 2.79-9.42 9.55-8.55 11 .86 1.47 3.92-1.71 3.92-1.71s9.58-8.71 11.66-6.44c2.08 2.27-1.58 4.17-6.8 7.33-5.23 3.16-5.63 4-4.9 5.2.75 1.2 12.28-8.53 13.36-4.4 1.08 4.11-11.76 5.3-10.97 8.15.8 2.85 9.05-5.38 10.74-2.18 1.69 3.21-11.65 6.98-11.76 7.01-4.31 1.12-15.26 3.49-19.08-2.12Z" />
      </svg>
    ),
    hoverClass: 'hover:text-[#FFD21E] hover:bg-[#FFD21E]/10 hover:border-[#FFD21E]/30 hover:shadow-[#FFD21E]/10',
    tooltipColor: 'bg-[#2a2612] text-[#FFD21E] border-[#FFD21E]/30'
  },
  {
    name: 'Kaggle',
    url: 'https://www.kaggle.com/nottkoneko',
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 512 512" fill="currentColor">
        <path d="M398.09 503.141c-.53 1.904-2.539 2.856-5.923 2.856h-65.255a13.14 13.14 0 01-10.576-5.077l-107.77-137.595-29.93 28.661v106.396c.042.307.063.603.063.91 0 3.543-2.908 6.451-6.451 6.451-.307 0-.603-.021-.91-.063h-50.66a6.574 6.574 0 01-.909.063c-3.543 0-6.451-2.908-6.451-6.451 0-.307.02-.603.063-.91V13.362a6.574 6.574 0 01-.063-.91c0-3.542 2.908-6.45 6.451-6.45.307 0 .603.02.91.063h50.659c.307-.043.603-.064.91-.064 3.543 0 6.451 2.909 6.451 6.452 0 .306-.021.602-.063.91V312.03L307.77 181.416a15.247 15.247 0 0110.576-5.182h67.581a5.721 5.721 0 015.817 3.702 6.257 6.257 0 01-.74 6.663l-136.75 131.99L396.61 495.42c2.052 2.01 2.655 5.097 1.48 7.72z" />
      </svg>
    ),
    hoverClass: 'hover:text-[#20BEFF] hover:bg-[#20BEFF]/10 hover:border-[#20BEFF]/30 hover:shadow-[#20BEFF]/10',
    tooltipColor: 'bg-[#0f1d2a] text-[#20BEFF] border-[#20BEFF]/30'
  },
  {
    name: 'Ko-fi',
    url: 'https://ko-fi.com/notkoneko',
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.063 4.716 3.72 4.75 3.72 4.75h10.873c4.91 0 5.842-4.68 5.842-4.68s2.509-.043 3.391-2.224c.919-2.27.033-5.873-.016-5.873zm-3.053 4.797c-.558 1.376-2.053 1.376-2.053 1.376H15.93v-4.94h2.845s1.956.12 2.053 3.564z" />
        <path d="M12.723 9.42c-.521-.522-1.365-.522-1.887 0l-.836.837-.837-.837c-.521-.522-1.365-.522-1.886 0-.522.522-.522 1.366 0 1.887l2.723 2.723 2.723-2.723c.522-.521.522-1.365 0-1.887z" />
      </svg>
    ),
    hoverClass: 'hover:text-[#FF5E5B] hover:bg-[#FF5E5B]/10 hover:border-[#FF5E5B]/30 hover:shadow-[#FF5E5B]/10',
    tooltipColor: 'bg-[#2a1312] text-[#FF5E5B] border-[#FF5E5B]/30'
  },
  {
    name: 'X (Twitter)',
    url: 'https://x.com/NottKoneko',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993L14.234 10.162zm-2.04 2.373-1.07-1.53L3.078 1.488h3.181l6.046 8.647 1.07 1.53 8.602 12.302H18.79l-6.596-9.432z"/>
      </svg>
    ),
    hoverClass: 'hover:text-white hover:bg-white/10 hover:border-white/30 hover:shadow-white/10',
    tooltipColor: 'bg-gray-800 text-white border-gray-700'
  }
];

const About = () => {
  return (
    <div className="relative max-w-4xl mx-auto">
      {/* Floating Social Sidebar (Desktop) */}
      <div className="hidden lg:flex flex-col items-center gap-3 absolute top-6 -right-14 xl:-right-16 z-30">
        {socialLinks.map((item) => (
          <div key={item.name} className="relative group/btn">
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-10 h-10 rounded-xl bg-[#0a0a0f] border border-gray-800/80 text-gray-400 flex items-center justify-center transition-all duration-300 transform hover:scale-110 active:scale-95 shadow-lg ${item.hoverClass}`}
            >
              {item.icon}
            </a>
            {/* Sliding Tooltip */}
            <span className={`absolute right-full mr-3 top-1/2 -translate-y-1/2 px-2.5 py-1 text-[10px] font-mono rounded border opacity-0 pointer-events-none group-hover/btn:opacity-100 transition-all duration-300 translate-x-2 group-hover/btn:translate-x-0 whitespace-nowrap z-30 ${item.tooltipColor} shadow-xl`}>
              {item.name}
            </span>
          </div>
        ))}
      </div>

      <SEO
        title="About — NotKoneko"
        description="Learn about NotKoneko, studying Computer Science, Neuroscience, and Psychology at Arizona State University. Researching computational neuroscience, machine learning, and native systems."
        path="/about"
        keywords={['NotKoneko Bio', 'Koneko Bio', 'Koneko Researcher', 'Koneko Engineer', 'Arizona State University', 'Cognitive Neuroscience', 'AI Research Engineer']}
        schema={{
          '@context': 'https://schema.org',
          '@graph': [
            personSchema,
            {
              '@type': 'ProfilePage',
              '@id': 'https://portfolio.notkoneko.space/about#profile',
              name: 'About NotKoneko',
              url: 'https://portfolio.notkoneko.space/about',
              mainEntity: {
                '@id': 'https://portfolio.notkoneko.space/#person'
              }
            },
            getBreadcrumbSchema([
              { name: 'Home', url: '/' },
              { name: 'About', url: '/about' }
            ])
          ]
        }}
      />
      <div className="animate-fade-in-down space-y-10 py-2">
        {/* Hero Profile Banner */}
        <div className="bg-[#090714] p-6 sm:p-10 border border-purple-500/30 rounded-3xl shadow-[0_0_50px_rgba(232,121,249,0.08)] relative overflow-hidden space-y-6">
          <div className="absolute top-0 right-0 w-96 h-96 bg-purple-600/10 rounded-full blur-[140px] pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-pink-600/10 rounded-full blur-[140px] pointer-events-none" />

          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 relative z-10">
            <div className="space-y-3 max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-purple-950/50 border border-purple-500/40 text-purple-300 text-xs font-mono shadow-lg">
                <Sparkles className="w-3.5 h-3.5 text-fuchsia-400 animate-pulse" />
                ASU Student • Aspiring AI Research Engineer
              </div>
              <h1 className="text-3xl sm:text-5xl font-serif text-white tracking-wide leading-tight">
                About <span className="gradient-text-purple-fuchsia-pink">NotKoneko</span> <span className="font-mono text-2xl sm:text-4xl font-light text-fuchsia-400">=^..^=</span>
              </h1>
              <div className="text-xs sm:text-sm font-mono text-purple-300/90 tracking-wider">
                SOFTWARE ENGINEER // COGNITIVE NEUROSCIENCE // ASU
              </div>
              <p className="text-base sm:text-lg text-gray-300 leading-relaxed font-normal">
                I&apos;m a student at <strong className="text-white">Arizona State University</strong> exploring the intersection of <strong className="text-white">software engineering</strong> and <strong className="text-white">cognitive neuroscience</strong>. Most of my work centers on building <strong className="text-purple-300">deep learning models</strong>, a biometric iOS engine, and real-time infrastructure. Long-term, I&apos;m working toward developing computational foundations for <strong className="text-fuchsia-300">AI-driven neural regeneration</strong>.
              </p>
              {/* Social Links Row (Mobile/Tablet) */}
              <div className="flex flex-wrap items-center gap-3 pt-2 lg:hidden">
                {socialLinks.map((item) => (
                  <a
                    key={item.name}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-9 h-9 rounded-xl bg-[#0d0a1c] border border-purple-500/20 text-gray-400 flex items-center justify-center transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-md group/btn ${item.hoverClass}`}
                    title={item.name}
                  >
                    {item.icon}
                  </a>
                ))}
              </div>
            </div>

            <div className="bg-[#0d0a1c] p-5 rounded-2xl border border-purple-500/20 font-mono text-xs text-gray-400 space-y-2 shrink-0 w-full md:w-auto relative z-10 shadow-xl">
              <div className="flex justify-between items-center gap-6 border-b border-purple-500/20 pb-2">
                <span className="text-gray-400">Handle:</span>
                <span className="text-fuchsia-400 font-bold">NotKoneko</span>
              </div>
              <div className="flex justify-between items-center gap-6 border-b border-purple-500/20 pb-2">
                <span className="text-gray-400">University:</span>
                <span className="text-white">Arizona State</span>
              </div>
              <div className="flex justify-between items-center gap-6">
                <span className="text-gray-400">Core Goal:</span>
                <span className="text-purple-300 font-bold">AI Research Engineer</span>
              </div>
            </div>
          </div>
        </div>

        {/* Inspirational Quote Block */}
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          whileHover={{ y: -2, borderColor: "rgba(232, 121, 249, 0.4)" }}
          className="relative p-5 sm:p-6 rounded-2xl bg-[#090714] border border-purple-500/20 shadow-lg overflow-hidden group transition-all duration-500"
        >
          {/* Subtle Cohesive Glows */}
          <div className="absolute top-0 right-0 w-48 h-48 bg-purple-600/10 rounded-full blur-3xl pointer-events-none group-hover:scale-110 transition-transform duration-700" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-pink-600/10 rounded-full blur-3xl pointer-events-none group-hover:scale-110 transition-transform duration-700" />
          
          <div className="relative flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <div className="p-2.5 rounded-xl bg-purple-500/10 text-fuchsia-400 border border-purple-500/20 shrink-0 group-hover:scale-105 group-hover:rotate-3 transition-transform duration-300 ease-out">
              <Quote className="w-4 h-4" />
            </div>
            <div className="space-y-1.5 flex-1 text-sm sm:text-base leading-relaxed">
              <p className="text-gray-300 italic">
                &ldquo;I don't know how to build a dam, or get a million people involved in anything.&rdquo;
              </p>
              <p className="font-medium">
                <span className="gradient-text-purple-fuchsia-pink italic">
                  &ldquo;Let me tell you a secret: no one does when they begin. Ideas don't come out fully formed. They only become clear as you work on them. You just have to get started.&rdquo;
                </span>
              </p>
              <div className="flex justify-end pt-0.5">
                <span className="text-[9px] font-mono text-purple-400/80 uppercase tracking-widest">- Mark Zuckerberg, Harvard Commencement Address (2017)</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Featured AI Experience & Research Prospect Spotlight */}
        <section className="bg-[#090714] p-6 sm:p-8 rounded-3xl border border-purple-500/30 shadow-2xl relative overflow-hidden space-y-6">
          <div className="absolute top-0 right-0 w-80 h-80 bg-purple-600/10 rounded-full blur-[140px] pointer-events-none" />
          
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-purple-500/20 pb-4 relative z-10">
            <div className="flex items-center gap-3">
              <div className="p-3 rounded-2xl bg-purple-500/20 text-purple-300 border border-purple-500/30">
                <Brain className="w-6 h-6 text-fuchsia-400" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">AI Experience & Research Focus</h2>
                <p className="text-xs font-mono text-purple-400">Deep Learning • Bioacoustics • Theoretical Neural Frameworks</p>
              </div>
            </div>
            <span className="text-xs font-mono px-3 py-1 bg-purple-950/80 text-purple-300 border border-purple-500/40 rounded-full self-start sm:self-auto">
              Primary Focus
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 relative z-10 text-sm text-gray-300 leading-relaxed font-sans">
            <div className="bg-[#0d0a1c] p-5 rounded-2xl border border-purple-500/20 space-y-3">
              <h3 className="text-base font-bold text-white flex items-center gap-2">
                <Cpu className="w-4 h-4 text-fuchsia-400" /> Hands-on AI & ML Experience
              </h3>
              <p className="text-xs text-gray-400 leading-relaxed">
                Active in competitive machine learning on Kaggle (such as <strong className="text-gray-200">BirdCLEF+ 2026</strong>, achieving a 0.92207 V5 score using Google Perch v2 embeddings, ProtoSSM State Space Models, and multi-head cross-attention). Authoring synthesis papers like <strong className="text-gray-200">The Forgetting Paradox</strong>, connecting biological memory decay with neural network weight consolidation.
              </p>
              <div className="pt-2 flex gap-2">
                <Link to="/ideas/birdclef-2026" className="text-[11px] font-mono text-fuchsia-400 hover:text-fuchsia-300 flex items-center gap-1">
                  View BirdCLEF+ Project →
                </Link>
              </div>
            </div>

            <div className="bg-[#0d0a1c] p-5 rounded-2xl border border-purple-500/20 space-y-3">
              <h3 className="text-base font-bold text-white flex items-center gap-2">
                <Target className="w-4 h-4 text-pink-400" /> AI Research Trajectory
              </h3>
              <p className="text-xs text-gray-400 leading-relaxed">
                Investigating the crossover between cognitive neuroscience and scalable machine learning. My trajectory focuses on developing biologically plausible neural architectures, sequence modeling, and the computational groundwork for neural regeneration.
              </p>
              <div className="pt-2 flex gap-2">
                <Link to="/ideas/forgetting-curve-in-ai" className="text-[11px] font-mono text-pink-400 hover:text-pink-300 flex items-center gap-1">
                  Read Synthesis Paper →
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Core Focus & Background Grid */}
        <div className="space-y-4">
          <div className="text-xs font-mono tracking-widest text-purple-400/90 uppercase flex items-center gap-2">
            SYSTEMS & DOMAINS <span className="inline-block w-8 h-[1px] bg-purple-500/40" />
          </div>
          <h2 className="text-2xl font-serif text-white tracking-wide flex items-center gap-2.5">
            Core Technical Domains
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 font-mono">
            {/* Card 1: AI & Machine Learning */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-fuchsia-500/50 hover:shadow-[0_0_25px_rgba(232,121,249,0.15)] transition-all space-y-3 shadow-lg relative overflow-hidden group">
              <div className="flex items-center justify-between text-[11px] text-fuchsia-400 uppercase tracking-widest">
                <span>[ 01 // INTELLIGENCE ]</span>
                <Brain className="w-4 h-4 group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-lg font-bold text-white group-hover:text-fuchsia-300 transition-colors font-sans">Artificial Intelligence & ML</h3>
              <p className="text-xs text-gray-400 leading-relaxed font-sans">
                Engineering deep learning pipelines, state space models (SSM), foundation model fine-tuning, audio feature extraction, and competitive Kaggle benchmarks.
              </p>
            </div>

            {/* Card 2: Software Engineering & iOS */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-fuchsia-500/50 hover:shadow-[0_0_25px_rgba(232,121,249,0.15)] transition-all space-y-3 shadow-lg group">
              <div className="flex items-center justify-between text-[11px] text-fuchsia-400 uppercase tracking-widest">
                <span>[ 02 // ENGINE ]</span>
                <Smartphone className="w-4 h-4 group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-lg font-bold text-white group-hover:text-fuchsia-300 transition-colors font-sans">Native iOS Engineering</h3>
              <p className="text-xs text-gray-400 leading-relaxed font-sans">
                Developing high-performance iOS applications in Swift 6 & SwiftUI (such as NeuroSyn), integrating Apple HealthKit biometrics and ScreenTime telemetry.
              </p>
            </div>

            {/* Card 3: Discord Automation */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-pink-500/50 hover:shadow-[0_0_25px_rgba(244,114,182,0.15)] transition-all space-y-3 shadow-lg group">
              <div className="flex items-center justify-between text-[11px] text-pink-400 uppercase tracking-widest">
                <span>[ 03 // FLEET ]</span>
                <Bot className="w-4 h-4 group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-lg font-bold text-white group-hover:text-pink-300 transition-colors font-sans">Discord Infrastructure</h3>
              <p className="text-xs text-gray-400 leading-relaxed font-sans">
                Architecting 24/7 event-driven Discord bots (like Lyrika-Stanza) using Discord.js v14, Node.js, and SQLite, deployed on Wispbyte cloud servers.
              </p>
            </div>

            {/* Card 4: Cognitive Science */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-purple-400/50 hover:shadow-[0_0_25px_rgba(232,121,249,0.15)] transition-all space-y-3 shadow-lg group">
              <div className="flex items-center justify-between text-[11px] text-purple-400 uppercase tracking-widest">
                <span>[ 04 // PROTOCOL ]</span>
                <Sparkles className="w-4 h-4 group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-lg font-bold text-white group-hover:text-purple-200 transition-colors font-sans">Cognitive Science & Research</h3>
              <p className="text-xs text-gray-400 leading-relaxed font-sans">
                Applying triple-major insights from neuroscience and psychology to study memory decay, human-computer interaction, and computational cognitive modeling.
              </p>
            </div>
          </div>
        </div>

        {/* Workstation & Hardware Setup */}
        <div className="space-y-4">
          <div className="text-xs font-mono tracking-widest text-purple-400/90 uppercase flex items-center gap-2">
            Fun Stuff &gt;:3 <span className="inline-block w-8 h-[1px] bg-purple-500/40" />
          </div>
          <h2 className="text-2xl font-serif text-white tracking-wide flex items-center gap-2.5">
            Gaming & Workstation Setup
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 font-mono">
            {/* Card 1: Primary Rig */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-fuchsia-500/50 hover:shadow-[0_0_25px_rgba(232,121,249,0.15)] transition-all space-y-3 shadow-lg group">
              <div className="flex items-center justify-between text-[11px] text-fuchsia-400 uppercase tracking-widest">
                <span>[ 01 // RIG ]</span>
                <Laptop className="w-4 h-4 group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-lg font-bold text-white group-hover:text-fuchsia-300 transition-colors font-sans">ROG Zephyrus M16</h3>
              <p className="text-xs text-gray-400 leading-relaxed font-sans">
                Intel i9-13900H • RTX 4080 Laptop GPU
              </p>
            </div>

            {/* Card 2: Display Matrix */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-pink-500/50 hover:shadow-[0_0_25px_rgba(244,114,182,0.15)] transition-all space-y-3 shadow-lg group">
              <div className="flex items-center justify-between text-[11px] text-pink-400 uppercase tracking-widest">
                <span>[ 02 // Displays ]</span>
                <Monitor className="w-4 h-4 group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-lg font-bold text-white group-hover:text-pink-300 transition-colors font-sans">Triple Display Setup</h3>
              <p className="text-xs text-gray-400 leading-relaxed font-sans">
                2 External Monitors + Laptop Screen
              </p>
            </div>

            {/* Card 3: Peripherals */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-fuchsia-500/50 hover:shadow-[0_0_25px_rgba(232,121,249,0.15)] transition-all flex flex-col justify-between shadow-lg group">
              <div className="space-y-3">
                <div className="flex items-center justify-between text-[11px] text-fuchsia-400 uppercase tracking-widest">
                  <span>[ 03 // PERIPHERALS ]</span>
                  <div className="p-1.5 bg-fuchsia-500/10 text-fuchsia-400 border border-fuchsia-500/20 rounded-lg shrink-0 group-hover:scale-110 transition-transform">
                    <svg className="w-4 h-4 stroke-current fill-none" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
                      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                      <line x1="12" y1="19" x2="12" y2="22" />
                    </svg>
                  </div>
                </div>
                <div className="text-xs text-gray-300 space-y-1.5 font-sans">
                  <div className="flex items-center justify-between"><span className="text-gray-400 font-mono text-[11px]">Mouse:</span> <span className="text-white font-medium">Logitech G502 X</span></div>
                  <div className="flex items-center justify-between"><span className="text-gray-400 font-mono text-[11px]">Mic:</span> <span className="text-white font-medium">Fifine K688</span></div>
                  <div className="flex items-center justify-between"><span className="text-gray-400 font-mono text-[11px]">Audio:</span> <span className="text-fuchsia-300 font-medium">ILLIT Boom IEMs</span></div>
                </div>
              </div>
              <div className="pt-3 mt-3 border-t border-purple-500/20 text-[11px] font-mono text-fuchsia-400">
                Accessories for Productivity &amp; Gaming
              </div>
            </div>

            {/* Card 4: Gaming */}
            <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 hover:border-purple-400/50 hover:shadow-[0_0_25px_rgba(232,121,249,0.15)] transition-all flex flex-col justify-between shadow-lg group">
              <div className="space-y-3">
                <div className="flex items-center justify-between text-[11px] text-purple-400 uppercase tracking-widest">
                  <span>[ 04 // GAMING ]</span>
                  <div className="p-1.5 bg-purple-500/10 text-purple-400 border border-purple-500/20 rounded-lg shrink-0 group-hover:scale-110 transition-transform">
                    <svg className="w-4 h-4 stroke-current fill-none" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="6" y1="12" x2="10" y2="12" />
                      <line x1="8" y1="10" x2="8" y2="14" />
                      <circle cx="15" cy="13" r="1" />
                      <circle cx="18" cy="11" r="1" />
                      <rect x="2" y="6" width="20" height="12" rx="6" />
                    </svg>
                  </div>
                </div>
                
                <div className="space-y-2.5">
                  {/* Game 1: Valorant */}
                  <div className="flex items-center justify-between bg-[#0d0a1c] p-2.5 rounded-xl border border-purple-500/20 hover:border-[#ff4655]/40 transition-colors">
                    <div className="flex items-center gap-2.5">
                      <div className="p-1.5 rounded-lg bg-[#ff4655]/10 text-[#ff4655] shrink-0 border border-[#ff4655]/20">
                        <svg className="w-3.5 h-3.5 fill-[#ff4654] stroke-[#ff4654]" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                          <g>
                            <path d="M19.8,26.1h-0.2c-2.4,0-4.8,0-7.2,0c-0.3,0-0.5-0.1-0.6-0.3c-2.5-3.2-5.1-6.3-7.6-9.5C4.1,16.1,4,16,4,15.8 c0-3.1,0-6.1,0-9.2c0-0.1,0-0.2,0.1-0.2h0.1c5.2,6.5,10.4,13,15.5,19.5c0,0,0,0.1,0.1,0.1L19.8,26.1L19.8,26.1z" />
                            <path d="M27.8,16.3c-0.7,0.9-1.5,1.8-2.2,2.8c-0.2,0.2-0.4,0.3-0.6,0.3c-2.4,0-4.8,0-7.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.1-0.2 c0,0,0-0.1,0.1-0.1c2.4-3,4.7-5.9,7.1-8.9c1-1.2,2-2.5,2.9-3.7c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0.1,0,0.1,0,0.2 c0,3,0,6.1,0,9.1C28,16,27.9,16.2,27.8,16.3L27.8,16.3z" />
                          </g>
                        </svg>
                      </div>
                      <div>
                        <strong className="text-[#ff4655] text-xs font-sans block font-bold leading-tight">
                          Valorant
                        </strong>
                        <span className="text-gray-400 font-mono text-[10px]">
                          Rank: <span className="text-slate-300 font-medium">Silver 3</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Game 2: Roblox */}
                  <div className="flex items-center justify-between bg-[#0d0a1c] p-2.5 rounded-xl border border-purple-500/20 hover:border-fuchsia-400/40 transition-colors">
                    <div className="flex items-center gap-2.5">
                      <div className="p-1.5 rounded-lg bg-fuchsia-500/10 text-fuchsia-400 shrink-0 border border-fuchsia-500/20">
                        <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
                          <path d="M18.5 2.5L21.5 17.5L5.5 21.5L2.5 6.5L18.5 2.5ZM14.2 8.8L8.8 10.2L10.2 15.2L15.6 13.8L14.2 8.8Z" />
                        </svg>
                      </div>
                      <div>
                        <strong className="text-fuchsia-300 text-xs font-sans block font-bold leading-tight">
                          Roblox
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Status */}
              <div className="pt-3 mt-3 border-t border-purple-500/20 flex justify-between items-center text-[11px] font-mono">
                <span className="text-gray-400">Competitive &amp; Casual</span>
                <span className="text-purple-400">Region: NA</span>
              </div>
            </div>
          </div>

          {/* Discord Icon in Circle */}
          <div className="pt-6 border-t border-purple-500/20 flex items-center justify-center">
            <a 
              href="https://discord.com/users/885360220694511656"
              target="_blank"
              rel="noopener noreferrer"
              title="Connect on Discord"
              className="w-12 h-12 rounded-full bg-[#5865F2]/10 hover:bg-[#5865F2] border border-[#5865F2]/40 text-[#5865F2] hover:text-white flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg shadow-[#5865F2]/10 group"
            >
              <svg className="w-6 h-6 fill-current" viewBox="0 0 127.14 96.36">
                <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1,105.25,105.25,0,0,0,32.19-16.14c2.64-27.38-4.51-51.11-18.91-72.15ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,45.91,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,45.91,96.12,53,91.08,65.69,84.69,65.69Z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Trajectory Note */}
        <div className="bg-[#090714] p-6 rounded-2xl border border-purple-500/20 text-xs font-mono text-gray-400 leading-relaxed flex items-center justify-between gap-4 shadow-lg">
          <div>
            Building machine learning models and preparing research proposals for graduate programs in AI and cognitive science.
          </div>
          <span className="w-2.5 h-2.5 rounded-full bg-fuchsia-400 animate-pulse shrink-0" title="Active Focus" />
        </div>
      </div>
  </div>
  );
};

export default About;